const parsedScheme = (url: string): string | null => {
  try {
    return new URL(url).protocol.slice(0, -1).toLowerCase();
  } catch {
    return null;
  }
};

export const safeHref = (url: string | null | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }

  const scheme = parsedScheme(url);

  if (scheme === null || scheme === 'http' || scheme === 'https') {
    return url;
  }

  return undefined;
};
